import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  FormErrorComponent,
  FormInputComponent,
  FormInputDirective,
  FormLabelDirective,
  SvgComponent,
} from '@app/base-components';
import { contactFormUrl, NoWhiteSpaceValidator } from '@app/helpers';
import { SeoService } from '@app/services';
import { GlobalMessageService, GlobalMessageType, I18nModule, PageRobotsMeta } from 'haba-core';
import { EmporixInvoiceService } from 'haba-emporix';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-invoice-download',
  templateUrl: './invoice-download.component.html',
  imports: [
    ReactiveFormsModule,
    FormInputComponent,
    FormLabelDirective,
    FormInputDirective,
    FormErrorComponent,
    SvgComponent,
    I18nModule,
    RouterModule,
  ],
})
export class InvoiceDownloadComponent implements OnInit {
  readonly contactFormUrl = contactFormUrl;
  isBrowser: boolean;

  public invoicePdfDownload: FormGroup = this.fb.group({
    customerNr: ['', [Validators.required, NoWhiteSpaceValidator()]],
    invoiceNr: ['', [Validators.required, NoWhiteSpaceValidator()]],
  });

  constructor(
    protected fb: FormBuilder,
    private seoService: SeoService,
    private invoiceService: EmporixInvoiceService,
    private globalMessageService: GlobalMessageService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.seoService.setSeoMetaData(
      'Rechnungskopie',
      'Rechnungskopie',
      PageRobotsMeta.NOINDEX,
      PageRobotsMeta.FOLLOW
    );
  }

  public getInvoicePdfDownload(): void {
    if (this.invoicePdfDownload.invalid) {
      this.invoicePdfDownload.markAllAsTouched();
      return;
    }

    const customerNr = this.invoicePdfDownload.get('customerNr')?.value?.trim();
    const invoiceNr = this.invoicePdfDownload.get('invoiceNr')?.value.trim();

    if (customerNr && invoiceNr) {
      this.invoiceService
        .getInvoice(invoiceNr, customerNr)
        .pipe(take(1))
        .subscribe(
          (response) => {
            window.open(URL.createObjectURL(response), '_blank');
          },
          (error) => {
            if (error.status === 400) {
              console.log('HTTP 400 Bad Request Error: ', error);
              this.globalMessageService.add(
                { key: 'habaCustomerData.invoiceDownload.notFound' },
                GlobalMessageType.MSG_TYPE_ERROR,
                10000
              );
            } else {
              console.error('An error occurred: ', error);
              this.globalMessageService.add(
                { key: 'habaHttpHandlers.featureNotAvailable' },
                GlobalMessageType.MSG_TYPE_ERROR,
                10000
              );
            }
            if (this.isBrowser) {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }
        );
    }
  }
}
